module.exports = __webpack_public_path__ + "img/9fa1a1b66885c62f2a2212a2ff332b23.png";